import { templateService } from '@/api/templates'

const taxRateCache = new Map()
const pendingRequests = new Map()

export const getTaxRateById = async (taxRateId) => {
  if (!taxRateId) {
    return null
  }

  if (taxRateCache.has(taxRateId)) {
    return taxRateCache.get(taxRateId)
  }

  if (pendingRequests.has(taxRateId)) {
    return pendingRequests.get(taxRateId)
  }

  const fetchPromise = (async () => {
    try {
      const response = await templateService.getTaxRateById(taxRateId)
      const taxRate = response?.data || response

      if (!taxRate) {
        taxRateCache.set(taxRateId, null)
        return null
      }

      const normalized = {
        id: taxRate.id || taxRateId,
        rate: Number(taxRate.rate) || 0,
        displayName: taxRate.displayName || taxRate.name || `${Number(taxRate.rate) || 0}%`,
      }

      taxRateCache.set(taxRateId, normalized)
      return normalized
    } catch (error) {
      console.warn(`[taxRateCache] Fehler beim Laden des Steuersatzes ${taxRateId}:`, error)
      taxRateCache.set(taxRateId, null)
      return null
    } finally {
      pendingRequests.delete(taxRateId)
    }
  })()

  pendingRequests.set(taxRateId, fetchPromise)
  return fetchPromise
}

export const primeTaxRates = (taxRates = []) => {
  if (!Array.isArray(taxRates)) return
  taxRates.forEach((taxRate) => {
    if (!taxRate || !taxRate.id) return
    taxRateCache.set(taxRate.id, {
      id: taxRate.id,
      rate: Number(taxRate.rate) || 0,
      displayName: taxRate.displayName || taxRate.name || `${Number(taxRate.rate) || 0}%`,
    })
  })
}

export const clearTaxRateCache = () => {
  taxRateCache.clear()
  pendingRequests.clear()
}
